import { render, staticRenderFns } from "./StepProgress.vue?vue&type=template&id=131251ff&scoped=true&"
import script from "./StepProgress.vue?vue&type=script&lang=ts&"
export * from "./StepProgress.vue?vue&type=script&lang=ts&"
import style0 from "./StepProgress.vue?vue&type=style&index=0&id=131251ff&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131251ff",
  null
  
)

export default component.exports